export default __webpack_public_path__ + "6edbe3ab2517c4ed6b32619d910367bc.png";